import { graphql } from "msw";

import {
  RecommendedEventsV2Query,
  RecommendedEventsV2QueryVariables,
} from "@personalisation/generated/graphql";

import { recommendedEvents } from "./RecommendedEvents.mock";

export const handler = graphql.query<
  RecommendedEventsV2Query,
  RecommendedEventsV2QueryVariables
>("recommendedEventsV2", (_request, response, context) => {
  return response(
    context.data({
      __typename: "Query" as const,
      recommendedEventsV2: {
        __typename: "RecommendedEventsV2Response" as const,
        events: recommendedEvents,
        metaData: {
          hydrationErrorCount: 0,
          preHydrationCount: 1,
          postHydrationCount: 1,
          __typename: "RecommenderMetaData" as const,
        },
      },
    })
  );
});
